import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, ShieldAlert, Flame } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <Flame className="w-6 h-6 text-[#C4A08A]" data-id="element-150" />,
    title: 'Reacción',
    desc: 'Ardor y rojez que aparecen de la nada.'
  }, {
    icon: <ShieldAlert className="w-6 h-6 text-[#C4A08A]" data-id="element-151" />,
    title: 'Barrera debilitada',
    desc: 'Tirantez y sensibilidad extrema.'
  }, {
    icon: <AlertCircle className="w-6 h-6 text-[#C4A08A]" data-id="element-152" />,
    title: 'Brotes',
    desc: 'Granitos e imperfecciones persistentes.'
  }];
  return <section className="py-24 px-4 bg-[#FBF7F4]" data-id="element-153">
      <div className="max-w-4xl mx-auto" data-id="element-154">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-155">
          <span className="text-[#8B7355] text-sm tracking-widest uppercase font-medium mb-4 block" data-id="element-156">
            Esto no es “otro skincare”
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-[#2D2A26] mb-6" data-id="element-157">
            El problema real: no es tu fuerza de voluntad
          </h2>
          <p className="text-lg text-[#2D2A26]/70 max-w-2xl mx-auto" data-id="element-158">
            Es que estás intentando resolver 3 problemas distintos con una sola
            estrategia. Si tratas un brote como si fuera el único problema…
            terminas destruyendo la barrera.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-159">
          {problems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-sm shadow-sm border border-[#8B7355]/10 text-center hover:shadow-md transition-shadow duration-300" data-id="element-160">
              <div className="bg-[#FBF7F4] w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-161">
                {item.icon}
              </div>
              <h3 className="text-xl font-serif text-[#2D2A26] mb-2" data-id="element-162">
                {item.title}
              </h3>
              <p className="text-[#2D2A26]/70" data-id="element-163">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 text-center p-6 bg-[#C4A08A]/10 rounded-lg border border-[#C4A08A]/20" data-id="element-164">
          <p className="text-lg md:text-xl font-serif italic text-[#8B7355]" data-id="element-165">
            "Y una barrera rota = piel que reacciona a todo."
          </p>
        </motion.div>
      </div>
    </section>;
}